// extracted by mini-css-extract-plugin
export var assigneeBadge = "_md-0";
export var assigneeDetails = "_md-1";
export var assigneeInfo = "_md-2";
export var dropdownContainer = "_md-4";
export var dropdownImage = "_md-5";
export var editAssigneeInfo = "_md-3";
export var editAssigneeModalContainer = "_md-6";
export var hidden = "_md-8";
export var input = "_md-7";